export const PUBLIC_COLOR_PALETTES = [
  // Palette taken from Figma: https://www.figma.com/file/YdmGxJl7UMwTuRClvOSFbk/Brand-Kit?type=design&node-id=1006-34224&mode=design&t=QM7XIxvIGy66KIPu-0
  // Update Palette taken from Figma (09-02-2023): https://www.figma.com/file/ngq4pYMDEnNW1BGyc7OaBD/Style-shuffle-combinations?type=design&node-id=1-710&mode=design&t=eD8qUN68c4WDKqAm-0
  ['#E5F1F5', '#459C85', '#3257B9', '#0A1226'],
  ['#77BEE8', '#004B90', '#001D3D', '#FFC300'],
  ['#EAA72C', '#16A197', '#207DA3', '#CF265A', '#07003B'],
  ['#64B079', '#57A9A4', '#407C78', '#0E1C1B'],
  ['#D4DBFF', '#121D5E', '#001D3D'],
  ['#F9F9F2', '#A5669A', '#785A96', '#211929'],
  ['#3B6CCF', '#00A887', '#F0B62A', '#F1624C', '#0D1226'],
  ['#2BB0CC', '#2492A9', '#8643FC', '#552BA0', '#5C73F5', '#4B5EC8', '#1A1A12'],
  ['#F2EFE7', '#C1BAAD', '#A8A196', '#70848D', '#2F2F23'],
  ['#E2E6ED', '#B20710', '#051838'],
  ['#CDDC39', '#8BC34A', '#4CAF50', '#210C0D'],
  ['#03A9F4', '#673AB7', '#1A1E46', '#0C0E22'],
  ['#E8D889', '#CFA622', '#7BD1B1', '#2C8A63', '#84D7E0', '#0291A4', '#AABFE8'],
  ['#FFBE03', '#29305C'],
  ['#FDF6DF', '#DCB486', '#9A5047', '#999879', '#5D756C', '#405664', '#2E3C37'],
  ['#FFDDCD', '#F2BBA2', '#AD4042', '#210C0D'],
];
